import { PagaduriaService } from './../../../_services/pagaduria.service';
import { Pagaduria } from "./../../../_models/pagaduria";
import { NavService } from "./../../../_services/_nav.service";
import { Component, OnInit } from "@angular/core";
import { forkJoin } from "rxjs";
import { ActivatedRoute, Params } from "@angular/router";
import { Location } from '@angular/common';
import {DivisionPolitica} from '../../../_models/division-politica';
import {DivisionPoliticaService} from '../../../_services/division-politica.service';

@Component({
  selector: "app-pagaduria-detalle",
  templateUrl: "./pagaduria-detalle.component.html",
  styleUrls: ["./pagaduria-detalle.component.css"],
})
export class PagaduriaDetalleComponent implements OnInit {
  carInformacionInicial = true;
  pagaduria: Pagaduria;
  departamento: DivisionPolitica;
  divisionPolitica: DivisionPolitica;

  constructor(
    private navServicio: NavService,
    private route: ActivatedRoute,
    private location: Location,
    private pagaduriaService: PagaduriaService,
    private divisionPoliticaServicio: DivisionPoliticaService
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      forkJoin(this.pagaduriaService.getById(params['id'])).subscribe(async ([pagaduria]) => {
        this.pagaduria = pagaduria;
        const ciudad = await this.divisionPoliticaServicio.viewDivisionPolitica(this.pagaduria.idDivisionPoliticaPadre).toPromise();
        this.departamento = await this.divisionPoliticaServicio.viewDivisionPolitica(ciudad.idDivisionPoliticaPadre).toPromise();
        this.divisionPolitica = ciudad;
        this.carInformacionInicial = false;
      });
    });
  }

  regresar() {
    this.location.back();
  }
}
